import { render, staticRenderFns } from "./AdminWorkspaceGroups.vue?vue&type=template&id=5f62c398&scoped=true&"
import script from "./AdminWorkspaceGroups.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspaceGroups.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspaceGroups.vue?vue&type=style&index=0&id=5f62c398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62c398",
  null
  
)

export default component.exports